const DrawSquareIcon = ({ ...props }) => {
    return (<svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        {...props}
    >
        <path d="M3.62913 14.5001L3.62911 3.62922L14.4999 3.62922L14.4999 14.5L3.62913 14.5001Z" stroke="#0C0C0C" strokeWidth="1.5" />
        <rect x="13" y="2" width="3" height="3" fill="#0C0C0C" />
        <rect x="2" y="2" width="3" height="3" fill="#0C0C0C" />
        <rect x="13" y="13" width="3" height="3" fill="#0C0C0C" />
        <rect x="2" y="13" width="3" height="3" fill="#0C0C0C" />
    </svg>);
};

export default DrawSquareIcon;
